import { VendorBuyOpportunities } from '../../../components/Vendor';

export function BuyOpportunities() {
  return <VendorBuyOpportunities />;
}
